import { html } from "lit";
import { renderStandardPictureElement, getDummyText } from "../../../../utils";
import { ProductDetailTabHeader } from "./shared";

interface ItemType {
    title: string;
    description: string;
}

const highlightItems: ItemType[] = [
    {
        title: "2-Gang-Getriebe",
        description:
            "Gewährleistet perfekte Resultate je nach Materialdicke, Festigkeit und Art des Werkstücks.",
    },
    {
        title: "2600 W-Motor",
        description:
            "Der extrem leistungsstarke Motor sorgt für eine hohe Dauerbelastbarkeit.",
    },
    {
        title: "Sicheres Arbeiten",
        description:
            "Der integrierte Handschutz am Motor bietet Ihnen eine hohe Arbeitssicherheit.",
    },
    {
        title: "Die richtige Einstellung",
        description:
            "Die optimale Einstellung von Fasenhöhe und Blechdicke erfolgt schnell und einfach.",
    },
    {
        title: "Stufenlos von 20° - 55°",
        description:
            "Sie können das Trägerteil für unterschiedliche Winkel zwischen 20° - 55° einsetzen.",
    },
];

const renderHighlightItem = (item: ItemType) => html`
    <!-- BEGIN Highlight Item -->
    <div class="ux-col-12 ux-col-sm-6 ux-u-margin-bottom-25">
        <div data-same-height="item" class="ux-u-margin-bottom-10">
            <span
                class="ux-text-title ux-text-title--bold ux-text-title--green-square"
            >
                ${item.title}
            </span>
            <div class="ux-text-normal ux-text-normal--light-gray">
                <p>${item.description}</p>
            </div>
        </div>
        <div class="ux-u-border-top"></div>
    </div>
    <!-- END Highlight Item -->
`;

export const HighlightsBlockTemplate = () => html`
    <!-- BEGIN Highlights Block -->
    <div class="ux-t-container ux-u-my-fluid-xs">
        <ux-same-height class="ux-row">
            ${highlightItems.map(renderHighlightItem)}
        </ux-same-height>
    </div>
    <!-- END Highlights Block -->
`;

const infoItems: ItemType[] = [
    {
        title: "TruTool TKF 1500 mit 2-Gang-Getriebe, Maßzeichnung",
        description: getDummyText(300),
    },
    {
        title: "Die richtige Wahl",
        description: getDummyText(400),
    },
    {
        title: "Angepasste Geschwindigkeit",
        description: getDummyText(200),
    },
];

const renderInfoItem = (item: ItemType, index: number) => html`
    <!-- BEGIN Info Item -->
    <div
        class="ux-row image-text-teaser ${index % 2 === 1
            ? "ux-u-flex-dir-md-row-reverse"
            : ""}"
    >
        <!-- Image -->
        <div class="ux-col-12 ux-col-md-6 ux-u-px-md-zero">
            ${renderStandardPictureElement({
                width: 1600,
                height: 900,
            })}
        </div>
        <!-- Text -->
        <div class="ux-col-12 ux-col-md-6 ux-u-pt-xs ux-u-px-xs">
            <div class="ux-text-title ux-text-title--light">${item.title}</div>
            <p class="ux-text-normal">${item.description}</p>
        </div>
    </div>
    <!-- END Info Item -->
`;

export const InfosBlockTemplate = () => html`
    <!-- BEGIN Infos Block -->
    <div class="ux-t-container-full ux-u-my-fluid-m">
        <div class="ux-row ux-u-mx-zero ux-u-flex-jc-center">
            <div class="ux-col-12 ux-col-sm-10">
                ${infoItems.map(renderInfoItem)}
            </div>
        </div>
    </div>
    <!-- END Infos Block -->
`;

const renderVideoSlide = () => html`
    <ux-slider-slide>
        <div class="embed-video">
            <div class="ux-u-margin-bottom-15">
                <ux-video>
                    <video controls preload="none">
                        <source
                            src="https://media.trumpf.com/m/333790ceedfb1be9/original/Schweikantenformer-Video-uber-den-Einsatzbereich.mp4"
                            type="video/mp4"
                        />
                    </video>
                </ux-video>
            </div>
            <div class="ux-u-margin-bottom-30 ux-u-text-align--left caption">
                <p class="ux-text-normal">
                    Schweißkantenformer: Video über den Einsatzbereich
                </p>
            </div>
        </div>
    </ux-slider-slide>
`;

export const VideoBlockTemplate = ({ numSlides = 1 } = {}) => html`
    <!-- BEGIN Video Block -->
    <div class="ux-t-container-full ux-u-my-fluid-m">
        <div class="ux-row ux-u-mx-zero ux-u-flex-jc-center">
            <div class="ux-col-12 ux-col-sm-10 ux-u-px-sm-zero">
                <ux-slider loop no-arrows>
                    ${new Array(numSlides || 1)
                        .fill("")
                        .map(() => renderVideoSlide())}
                </ux-slider>
            </div>
        </div>
    </div>
    <!-- END Video Block -->
`;

export const TabOverview = () => html`
    <div id="tabOverview">
        ${ProductDetailTabHeader({
            headline: "Der Leistungsstarke mit 2 Gängen",
            description: getDummyText(399),
        })}
        ${HighlightsBlockTemplate()} ${VideoBlockTemplate()}
        ${InfosBlockTemplate()}
    </div>
`;
